// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.super-pickem-my-picks-navigation {
  width: 100%;
  background-color: #E8E8E8;
  padding: 0 16px;
  box-sizing: border-box;
  border-bottom: 2px solid #002129;
}
.super-pickem-my-picks-navigation__content {
  margin: 0 auto;
  width: 310px;
}
@media (min-width: 600px) {
  .super-pickem-my-picks-navigation__content {
    width: 467px;
  }
}
.super-pickem-my-picks-navigation__game-date-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.super-pickem-my-picks-navigation__icon {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
}
.super-pickem-my-picks-navigation__icon:hover, .super-pickem-my-picks-navigation__icon:focus {
  outline: none; /* Remove the thin outline */
}
.super-pickem-my-picks-navigation__icon:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.super-pickem-my-picks-navigation__icon svg {
  font-size: 24px;
  color: #002129;
}
.super-pickem-my-picks-navigation__icon svg:hover, .super-pickem-my-picks-navigation__icon svg:focus {
  outline: none; /* Remove the thin outline on the SVG icons */
}
.super-pickem-my-picks-navigation__week-select-container {
  display: flex;
  align-items: center;
}
.super-pickem-my-picks-navigation__week-select {
  color: white;
}
.super-pickem-my-picks-navigation__week-select:hover, .super-pickem-my-picks-navigation__week-select:focus {
  outline: none; /* Remove the outline around the select */
  border-color: transparent; /* Remove any border */
}
.super-pickem-my-picks-navigation__week-select .MuiSelect-select {
  color: #002129;
  font-weight: 500;
  display: flex;
  align-items: center;
  font-size: 18px; /* Default font size for small screens */
}
@media (min-width: 768px) {
  .super-pickem-my-picks-navigation__week-select .MuiSelect-select {
    font-size: 24px; /* Larger font size for bigger screens */
  }
}
.super-pickem-my-picks-navigation__week-select .MuiOutlinedInput-notchedOutline {
  border-color: transparent;
}
.super-pickem-my-picks-navigation__week-select .MuiSvgIcon-root {
  color: #002129;
  font-size: 32px;
  margin-left: 8px;
  margin-right: -8px;
}
.super-pickem-my-picks-navigation__week-select .MuiMenuItem-root {
  color: #002129;
}
.super-pickem-my-picks-navigation__week-select .MuiMenuItem-root.Mui-selected {
  color: #002129;
  background-color: #002129;
}

.super-pickem-my-picks-navigation-flipped {
  width: 100%;
  background-color: #002129;
  padding: 0 16px;
  box-sizing: border-box;
  border-bottom: 2px solid #E8E8E8;
}
.super-pickem-my-picks-navigation-flipped__content {
  margin: 0 auto;
  width: 310px;
}
@media (min-width: 600px) {
  .super-pickem-my-picks-navigation-flipped__content {
    width: 467px;
  }
}
.super-pickem-my-picks-navigation-flipped__game-date-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.super-pickem-my-picks-navigation-flipped__icon {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
}
.super-pickem-my-picks-navigation-flipped__icon:hover, .super-pickem-my-picks-navigation-flipped__icon:focus {
  outline: none;
}
.super-pickem-my-picks-navigation-flipped__icon:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.super-pickem-my-picks-navigation-flipped__icon svg {
  font-size: 24px;
  color: #E8E8E8;
}
.super-pickem-my-picks-navigation-flipped__icon svg:hover, .super-pickem-my-picks-navigation-flipped__icon svg:focus {
  outline: none;
}
.super-pickem-my-picks-navigation-flipped__week-select-container {
  display: flex;
  align-items: center;
}
.super-pickem-my-picks-navigation-flipped__week-select {
  color: white;
}
.super-pickem-my-picks-navigation-flipped__week-select:hover, .super-pickem-my-picks-navigation-flipped__week-select:focus {
  outline: none;
  border-color: transparent;
}
.super-pickem-my-picks-navigation-flipped__week-select .MuiSelect-select {
  color: #E8E8E8;
  font-weight: 500;
  display: flex;
  align-items: center;
  font-size: 18px;
}
@media (min-width: 768px) {
  .super-pickem-my-picks-navigation-flipped__week-select .MuiSelect-select {
    font-size: 24px;
  }
}
.super-pickem-my-picks-navigation-flipped__week-select .MuiOutlinedInput-notchedOutline {
  border-color: transparent;
}
.super-pickem-my-picks-navigation-flipped__week-select .MuiSvgIcon-root {
  color: #E8E8E8;
  font-size: 32px;
  margin-left: 8px;
  margin-right: -8px;
}
.super-pickem-my-picks-navigation-flipped__week-select .MuiMenuItem-root {
  color: #E8E8E8;
}
.super-pickem-my-picks-navigation-flipped__week-select .MuiMenuItem-root.Mui-selected {
  color: #E8E8E8;
  background-color: #E8E8E8;
}`, "",{"version":3,"sources":["webpack://./src/components/SuperPickem/MyPicks/SuperPickemMyPicksNavBar.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,yBAAA;EACA,eAAA;EACA,sBAAA;EACA,gCAAA;AACJ;AACI;EACE,cAAA;EACA,YAAA;AACN;AACM;EAJF;IAKI,YAAA;EAEN;AACF;AACI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AACN;AAEI;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AAAN;AAEM;EACE,aAAA,EAAA,4BAAA;AAAR;AAGM;EACE,YAAA;EACA,mBAAA;AADR;AAIM;EACE,eAAA;EACA,cAAA;AAFR;AAIQ;EACE,aAAA,EAAA,6CAAA;AAFV;AAOI;EACE,aAAA;EACA,mBAAA;AALN;AAQI;EACE,YAAA;AANN;AAQM;EACE,aAAA,EAAA,yCAAA;EACA,yBAAA,EAAA,sBAAA;AANR;AASM;EACE,cAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EAEA,eAAA,EAAA,wCAAA;AARR;AAUQ;EARF;IASI,eAAA,EAAA,wCAAA;EAPR;AACF;AAUM;EACE,yBAAA;AARR;AAWM;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AATR;AAYM;EACE,cAAA;AAVR;AAYQ;EACE,cAAA;EACA,yBAAA;AAVV;;AAoBE;EACE,WAAA;EACA,yBAAA;EACA,eAAA;EACA,sBAAA;EACA,gCAAA;AAjBJ;AAmBI;EACE,cAAA;EACA,YAAA;AAjBN;AAmBM;EAJF;IAKI,YAAA;EAhBN;AACF;AAmBI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAjBN;AAoBI;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AAlBN;AAoBM;EACE,aAAA;AAlBR;AAqBM;EACE,YAAA;EACA,mBAAA;AAnBR;AAsBM;EACE,eAAA;EACA,cAAA;AApBR;AAsBQ;EACE,aAAA;AApBV;AAyBI;EACE,aAAA;EACA,mBAAA;AAvBN;AA0BI;EACE,YAAA;AAxBN;AA0BM;EACE,aAAA;EACA,yBAAA;AAxBR;AA2BM;EACE,cAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EAEA,eAAA;AA1BR;AA4BQ;EARF;IASI,eAAA;EAzBR;AACF;AA4BM;EACE,yBAAA;AA1BR;AA6BM;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AA3BR;AA8BM;EACE,cAAA;AA5BR;AA8BQ;EACE,cAAA;EACA,yBAAA;AA5BV","sourcesContent":[".super-pickem-my-picks-navigation {\n    width: 100%;\n    background-color: #E8E8E8;\n    padding: 0 16px;\n    box-sizing: border-box;\n    border-bottom: 2px solid #002129;\n  \n    &__content {\n      margin: 0 auto;\n      width: 310px;\n  \n      @media (min-width: 600px) {\n        width: 467px;\n      }\n    }\n  \n    &__game-date-bar {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n    }\n  \n    &__icon {\n      background: none;\n      border: none;\n      color: white;\n      cursor: pointer;\n  \n      &:hover, &:focus {\n        outline: none; /* Remove the thin outline */\n      }\n  \n      &:disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n      }\n  \n      svg {\n        font-size: 24px;\n        color: #002129;\n  \n        &:hover, &:focus {\n          outline: none; /* Remove the thin outline on the SVG icons */\n        }\n      }\n    }\n  \n    &__week-select-container {\n      display: flex;\n      align-items: center;\n    }\n  \n    &__week-select {\n      color: white;\n  \n      &:hover, &:focus {\n        outline: none; /* Remove the outline around the select */\n        border-color: transparent; /* Remove any border */\n      }\n  \n      .MuiSelect-select {\n        color: #002129;\n        font-weight: 500;\n        display: flex;\n        align-items: center;\n  \n        font-size: 18px; /* Default font size for small screens */\n  \n        @media (min-width: 768px) {\n          font-size: 24px; /* Larger font size for bigger screens */\n        }\n      }\n  \n      .MuiOutlinedInput-notchedOutline {\n        border-color: transparent;\n      }\n  \n      .MuiSvgIcon-root {\n        color: #002129;\n        font-size: 32px;\n        margin-left: 8px;\n        margin-right: -8px;\n      }\n  \n      .MuiMenuItem-root {\n        color: #002129;\n  \n        &.Mui-selected {\n          color: #002129;\n          background-color: #002129;\n        }\n      }\n    }\n  }\n  \n\n\n\n\n  .super-pickem-my-picks-navigation-flipped {\n    width: 100%;\n    background-color: #002129;\n    padding: 0 16px;\n    box-sizing: border-box;\n    border-bottom: 2px solid #E8E8E8;\n  \n    &__content {\n      margin: 0 auto;\n      width: 310px;\n  \n      @media (min-width: 600px) {\n        width: 467px;\n      }\n    }\n  \n    &__game-date-bar {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n    }\n  \n    &__icon {\n      background: none;\n      border: none;\n      color: white;\n      cursor: pointer;\n  \n      &:hover, &:focus {\n        outline: none;\n      }\n  \n      &:disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n      }\n  \n      svg {\n        font-size: 24px;\n        color: #E8E8E8;\n  \n        &:hover, &:focus {\n          outline: none;\n        }\n      }\n    }\n  \n    &__week-select-container {\n      display: flex;\n      align-items: center;\n    }\n  \n    &__week-select {\n      color: white;\n  \n      &:hover, &:focus {\n        outline: none;\n        border-color: transparent;\n      }\n  \n      .MuiSelect-select {\n        color: #E8E8E8;\n        font-weight: 500;\n        display: flex;\n        align-items: center;\n  \n        font-size: 18px;\n  \n        @media (min-width: 768px) {\n          font-size: 24px;\n        }\n      }\n  \n      .MuiOutlinedInput-notchedOutline {\n        border-color: transparent;\n      }\n  \n      .MuiSvgIcon-root {\n        color: #E8E8E8;\n        font-size: 32px;\n        margin-left: 8px;\n        margin-right: -8px;\n      }\n  \n      .MuiMenuItem-root {\n        color: #E8E8E8;\n  \n        &.Mui-selected {\n          color: #E8E8E8;\n          background-color: #E8E8E8;\n        }\n      }\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
